const sortByName = <T extends { name: string }>(data: T[]): T[] => {
    const array = [...data];
    array.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });
    return array;
};

export default sortByName;
